<template>
  <div class="calc_vessels__list_row border-b border-gray-light active:child-inputs-inset-shadow" @click="onSelect">
<!--    <div class="click-zone position-absolute h100Proc t0 l0" >-->

<!--    </div>-->
    <div class="p-l-2">
      <button type="button" class="fz0 m-r-2" @click.stop="vessel.is_favorite = !vessel.is_favorite" :disabled="!isAllow">
        <svg v-if="!vessel.is_favorite" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.182 10.051a.352.352 0 0 1 .199.614l-3.492 3.062-.224.196.066.29 1.03 4.534a.35.35 0 0 1-.522.38l-3.982-2.382-.257-.153-.257.154-3.982 2.38v.001a.348.348 0 0 1-.385-.017.35.35 0 0 1-.136-.363l1.029-4.534.066-.29-.224-.196-3.491-3.062a.352.352 0 0 1 .199-.614l4.619-.42.297-.026.117-.275 1.826-4.273a.35.35 0 0 1 .645 0l1.825 4.273.118.275.297.027 4.619.42Z" stroke="#BDCBD6"/></svg>
        <svg v-else width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.958 10.137a.85.85 0 0 0-.731-.584l-4.619-.42-1.825-4.273a.85.85 0 0 0-1.565 0L9.393 9.134l-4.62.42a.852.852 0 0 0-.483 1.487l3.491 3.062-1.03 4.534a.85.85 0 0 0 1.266.919L12 17.175l3.982 2.381a.85.85 0 0 0 1.266-.92l-1.03-4.533 3.492-3.062a.851.851 0 0 0 .248-.904Z" fill="#FF833E"/></svg>
      </button>
      <span 
        class="fw500 whitespace-nowrap overflow-hidden overflow-ellipsis"
        v-tooltip="vessel.name"
        v-if="!ifEditName"
      >{{vessel.name}}</span>

      <input 
        v-model.lazy="vessel.name" 
        type="text" 
        class="h-full p-y-0 p-l-0 p-r-2 border-0 bg-transparent rounded-none fz16 fw500"
        v-if="ifEditName"
        @blur="onSaveName"
        @keyup.enter="onSaveName"
        ref="inputName"
      >

<!--      <button v-tooltip="'Edit name'" class="fz0" @click.stop="onChangeName" v-if="isShowEditPen">-->
<!--        <svg class="m-l-1 flex-shrink-0" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m3.744 12.867.032-3.398L8.77 3.721c.347-.397.846-.615 1.406-.615.564 0 1.118.217 1.57.615.932.818 1.111 2.147.398 2.97L7.149 12.44l-3.405.428Z" stroke="#9AA3B0" stroke-width="1.4"/></svg>-->
<!--      </button>-->
<!--      getDuplicateNumber !== null && (''+getDuplicateNumber).length !== 0 && getDuplicateNumber != 1-->
      <button v-tooltip="'Replace'" class="fz0" @click.stop="$emit('on-replace')" v-if="vessel.is_duplicated">
<!--        <svg class="m-l-1 flex-shrink-0" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m3.744 12.867.032-3.398L8.77 3.721c.347-.397.846-.615 1.406-.615.564 0 1.118.217 1.57.615.932.818 1.111 2.147.398 2.97L7.149 12.44l-3.405.428Z" stroke="#9AA3B0" stroke-width="1.4"/></svg>-->
        <svg class="m-l-1 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.00026 8.09163C5.00026 7.91662 5.067 7.74878 5.1858 7.62503C5.3046 7.50128 5.46573 7.43176 5.63374 7.43176H16.5343L13.778 5.17962C13.6458 5.07146 13.5602 4.91302 13.5401 4.73915C13.5201 4.56529 13.5671 4.39023 13.6709 4.2525C13.7748 4.11477 13.9269 4.02564 14.0938 4.00473C14.2607 3.98381 14.4288 4.03283 14.561 4.14098L18.7578 7.57231C18.8332 7.63405 18.8943 7.71285 18.9362 7.80276C18.9782 7.89266 19 7.99133 19 8.0913C19 8.19127 18.9782 8.28993 18.9362 8.37984C18.8943 8.46975 18.8332 8.54854 18.7578 8.61029L14.561 12.0416C14.4288 12.1498 14.2609 12.1988 14.094 12.178C13.9272 12.1571 13.7751 12.0681 13.6713 11.9304C13.5674 11.7928 13.5203 11.6178 13.5404 11.444C13.5604 11.2702 13.6459 11.1118 13.778 11.0036L16.5343 8.7515H5.63374C5.46573 8.7515 5.3046 8.68198 5.1858 8.55823C5.067 8.43448 5.00026 8.26664 5.00026 8.09163ZM18.3663 15.0863H7.46575L10.222 12.8321C10.2874 12.7786 10.3421 12.7121 10.3829 12.6366C10.4236 12.561 10.4497 12.4778 10.4596 12.3918C10.4695 12.3057 10.4631 12.2185 10.4406 12.135C10.4182 12.0515 10.3802 11.9735 10.3287 11.9053C10.2773 11.8372 10.2135 11.7803 10.141 11.7378C10.0685 11.6953 9.98861 11.6681 9.90599 11.6578C9.82337 11.6475 9.73961 11.6542 9.65949 11.6776C9.57937 11.701 9.50445 11.7406 9.43902 11.7942L5.24225 15.2255C5.16677 15.2872 5.10574 15.366 5.06377 15.4559C5.02181 15.5458 5 15.6445 5 15.7445C5 15.8444 5.02181 15.9431 5.06377 16.033C5.10574 16.1229 5.16677 16.2017 5.24225 16.2635L9.43902 19.6948C9.50449 19.7483 9.57945 19.7879 9.65961 19.8113C9.73977 19.8347 9.82357 19.8414 9.90621 19.831C9.98886 19.8207 10.0687 19.7935 10.1413 19.751C10.2138 19.7085 10.2776 19.6515 10.3291 19.5833C10.3805 19.5151 10.4185 19.437 10.4409 19.3535C10.4634 19.27 10.4698 19.1827 10.4599 19.0966C10.4499 19.0105 10.4238 18.9273 10.383 18.8517C10.3422 18.7762 10.2875 18.7097 10.222 18.6562L7.46575 16.406H18.3663C18.5343 16.406 18.6954 16.3365 18.8142 16.2127C18.933 16.089 18.9997 15.9211 18.9997 15.7461C18.9997 15.5711 18.933 15.4033 18.8142 15.2795C18.6954 15.1558 18.5343 15.0863 18.3663 15.0863Z" fill="#2C2C2C"/>
        </svg>
        Replace
      </button>
      <div v-tooltip="getCreatorFullName" class="m-x-1 flex-shrink-0 fz0" v-if="!ifEditName && vessel.vessel == null && vessel.creator">
        <svg v-if="!vessel.creator.avatar" width="16" height="16" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="80" cy="80" r="80" fill="white"></circle><path d="M80 0.00308228C35.8218 0.00308228 0 35.8179 0 79.9996C0 124.181 35.8183 159.996 80 159.996C124.185 159.996 160 124.181 160 79.9996C160 35.8179 124.185 0.00308228 80 0.00308228ZM80 23.923C94.6183 23.923 106.464 35.7722 106.464 50.3835C106.464 64.9983 94.6183 76.844 80 76.844C65.3887 76.844 53.543 64.9983 53.543 50.3835C53.543 35.7722 65.3887 23.923 80 23.923ZM79.9824 139.081C65.4028 139.081 52.0495 133.771 41.75 124.982C39.241 122.842 37.7932 119.704 37.7932 116.412C37.7932 101.593 49.7865 89.7334 64.6086 89.7334H95.3984C110.224 89.7334 122.172 101.593 122.172 116.412C122.172 119.708 120.731 122.839 118.218 124.979C107.922 133.771 94.5656 139.081 79.9824 139.081Z" fill="#DEE3EA"></path></svg>
        <img :src="getDomen+vessel.creator.avatar" class="flex-shrink-0 w-4 h-4 rounded-full" v-else>
      </div>
      <p class="fw500 whitespace-nowrap ml-auto mr8" v-if="!ifEditName">{{getDuplicateNumber}}</p>
    </div>

    <div class="" v-tooltip="vessel.dwt ? `${vessel.dwt}` : null">
      <input
        type="number" 
        @click.stop
        class="p-y-1.5 p-x-2 border-0 bg-transparent rounded-none" 
        v-model.number.lazy="vessel.dwt"
        @keypress="onlyNumber($event)"
        @keyup.enter="$event.target.blur()"
        :disabled="!isAllow"
      >
    </div>

    <div class="" v-tooltip="vessel.year ? `${vessel.year}` : null">
      <input
        type="number" 
        @click.stop
        class="p-y-1.5 p-x-2 border-0 bg-transparent rounded-none" 
        v-model.number.lazy="vessel.year"
        @keypress="onlyNumber($event)"
        @keyup.enter="$event.target.blur()"
        :disabled="!isAllow"
      >
    </div>

    <div class="" v-tooltip="vessel.hire ? `${vessel.hire}` : null">
      <input
        type="number" 
        @click.stop
        class="p-y-1.5 p-x-2 border-0 bg-transparent rounded-none" 
        v-model.number.lazy="vessel.hire"
        @keypress="onlyNumber($event)"
        @keyup.enter="$event.target.blur()"
        :disabled="!isAllow"
      >
    </div>

    <div class="flex justify-center p-y-0.5">
      <option-vessel-drop @rename="onChangeName" :showRename="isShowEditPen" :showReplace="getDuplicateNumber !== null && (''+getDuplicateNumber).length !== 0 && getDuplicateNumber != 1" @replace="$emit('on-replace')" @delete="$emit('on-delete')" @duplicate="$emit('on-duplicate')" v-if="!exportPdf && isAllow"></option-vessel-drop>
<!--      <button type="button" class="fz0" @click.stop="$emit('on-delete')" v-if="!exportPdf && isAllow">-->
<!--        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.636 4.366a.225.225 0 0 0-.227.223v.675h3.182v-.675a.225.225 0 0 0-.227-.223h-2.728Zm4.319.898v-.675A1.59 1.59 0 0 0 13.364 3h-2.728a1.59 1.59 0 0 0-1.59 1.589v.675H5.181a.682.682 0 0 0 0 1.366h1.136v9.876A2.497 2.497 0 0 0 8.818 19h6.364c1.377 0 2.5-1.113 2.5-2.494V6.63h1.136a.682.682 0 0 0 0-1.366h-3.864ZM7.681 6.63v9.876c0 .62.505 1.128 1.136 1.128h6.364c.63 0 1.136-.509 1.136-1.128V6.63H7.682Zm2.954 2.256c.377 0 .682.306.682.683v4.981a.682.682 0 1 1-1.363 0V9.57c0-.378.305-.684.681-.684Zm2.728 0c.376 0 .681.306.681.683v4.981a.682.682 0 1 1-1.363 0V9.57c0-.378.305-.684.682-.684Z" fill="#9AA3B0"/></svg>-->
<!--      </button>-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OptionVesselDrop from "@/views/calc/option-vessel-drop";

export default {
  components: {OptionVesselDrop},
  props: {
    isAllow: Boolean,
    exportPdf: {
      type: Boolean,
      default: false,
    },
    vessel: Object,
  },
  data() {
    return {
      ifEditName: false,
      oldName: '',
    }
  },
  watch: {
    getWatchesData: function() {
      this.$emit('on-calc')
    },
    'vessel.dwt': function() {this.calcDwcc()},
    'vessel.constants': function() {this.calcDwcc()},
    'vessel.bob': function() {this.calcDwcc()},
    'vessel.fresh_water': function() {this.calcDwcc()},
  },
  computed: {
    ...mapGetters(['getLoginData']),

    getDuplicateNumber() {
      if(this.vessel['additional_info'] && this.vessel['additional_info']['duplicateNumber']) {
        return this.vessel['additional_info']['duplicateNumber']
      }
      return ''
    },
    isShowEditPen() {
      return !this.ifEditName && this.isAllow && this.vessel.vessel == null && this.vessel?.creator?.id == this.getLoginData?.data?.user?.id && !this.exportPdf
    },
    getCreatorFullName() {
      return 'Creator: '+this.vessel.creator.first_name + ' ' + this.vessel.creator.last_name
    },
    getDomen() {
      return process.env.VUE_APP_URL
    },
    getWatchesData() {
      let obj = {
        dwt: this.vessel.dwt,
        hire: this.vessel.hire,
        ballast_bonus: this.vessel.ballast_bonus,
        additional_commission: this.vessel.additional_commission,
        date: this.vessel.date,
        time: this.vessel.time,
        expenses: this.vessel.expenses,
        mins_cost: this.vessel.mins_cost,
        insurance: this.vessel.insurance,
        other: this.vessel.other,
        full_sp_ball: this.vessel.full_sp_ball,
        full_ifo_ball: this.vessel.full_ifo_ball,
        full_mgo_ball: this.vessel.full_mgo_ball,
        full_sp_lad: this.vessel.full_sp_lad,
        full_ifo_lad: this.vessel.full_ifo_lad,
        full_mgo_lad: this.vessel.full_mgo_lad,
        eco_sp_ball: this.vessel.eco_sp_ball,
        eco_ifo_ball: this.vessel.eco_ifo_ball,
        eco_mgo_ball: this.vessel.eco_mgo_ball,
        eco_sp_lad: this.vessel.eco_sp_lad,
        eco_ifo_lad: this.vessel.eco_ifo_lad,
        eco_mgo_lad: this.vessel.eco_mgo_lad,
        slow_sp_ball: this.vessel.slow_sp_ball,
        slow_ifo_ball: this.vessel.slow_ifo_ball,
        slow_mgo_ball: this.vessel.slow_mgo_ball,
        slow_sp_lad: this.vessel.slow_sp_lad,
        slow_ifo_lad: this.vessel.slow_ifo_lad,
        slow_mgo_lad: this.vessel.slow_mgo_lad,
        ifo_idle: this.vessel.ifo_idle,
        ifo_wk: this.vessel.ifo_wk,
        mgo_idle: this.vessel.mgo_idle,
        mgo_wk: this.vessel.mgo_wk,
        dwcc: this.vessel.dwcc,
        draft: this.vessel.draft,
        grain: this.vessel.grain,
        tpc: this.vessel.tpc,
        constants: this.vessel.constants,
        bob: this.vessel.bob,
        vlsfo_price: this.vessel.vlsfo_price,
        hsfo_price: this.vessel.hsfo_price,
        lsmgo_price: this.vessel.lsmgo_price,
        fresh_water: this.vessel.fresh_water,
        scrubber: this.vessel.scrubber,
      }
      return obj
    }
  },
  methods: {
    ...mapActions(['onlyNumber']),
    async onChangeName() {
      this.ifEditName = true
      await this.$nextTick()
      this.$refs.inputName.focus()
    },
    onSaveName() {
      this.ifEditName = false
      if(!this.vessel.name)
        this.vessel.name = 'Created Vessel'

      if(this.oldName !== this.vessel.name) {
        this.vessel['additional_info']['duplicateNumber'] = null
        this.$emit('renamed', this.oldName)
        this.oldName = JSON.parse(JSON.stringify(this.vessel.name))


      }
    },
    onSelect() {
      this.$emit('on-select')
    },
    calcDwcc() {
      let result = (this.vessel.dwt ? this.vessel.dwt : 0) - (this.vessel.constants ? this.vessel.constants : 0) - (this.vessel.bob ? this.vessel.bob : 0) - (this.vessel.fresh_water ? this.vessel.fresh_water : 0)
      this.vessel.dwcc = result ? result : null
    }
  },
  beforeMount() {
    if(!this.vessel.dwcc) this.calcDwcc()
  },
  mounted() {
    this.oldName = JSON.parse(JSON.stringify(this.vessel.name))
  }
}
</script>

<style lang="scss">
  .click-zone {
    width: calc(100% - 35px);
    box-sizing: border-box;
  }
</style>